<template>
  <nav class="navbar">
    <img id="logo" src="../assets/images/adalliance.png" alt="logo" @click="goToIndex">
    <div style="display: flex;flex-direction: row;align-items: center;cursor: pointer">
            <span class="toolName" @click="titleClicked">
                Uplift Barometer ©
            </span>
    </div>
    <AdaButton style="width: 250px" title="NEUE UMFRAGE ERSTELLEN" to="/survey/create" type="createButton"
               icon="icon-add"></AdaButton>
    <ul class="main-nav" id="js-menu" ref="mainNav">
      <router-link to="/surveys" class="nav-links tab">
        <li class="nav-li-item center"><span>Umfragen</span></li>
      </router-link>
      <router-link to="/layouts" class="nav-links tab">
        <li class="nav-li-item center"><span>Layouts</span></li>
      </router-link>
    </ul>
    <div id="logout" @click="logout()">
      <span class="icon icon-login"></span>
      <span>Logout</span>
    </div>
    <Dialog :show-close-button="true" :show="showDialog"
            :has-backdrop="true"
            @close="showDialog = false">
      <div>
        <h2>Sie wurden ausgeloggt</h2>
        <div style="margin-bottom: 30px">
          Um sich neu anzumelden, einfach die Seite neu laden.
        </div>
      </div>
    </Dialog>
  </nav>
</template>

<script>
import AdaButton from "./AdaButton";
import Dialog from "./Dialog";

export default {
  name: "Header",
  components: {
    AdaButton,
    Dialog
  },
  data: function () {
    return {
      showDialog: false
    }
  },
  methods: {
    logout() {
      // eslint-disable-next-line no-undef
      sso.init({
        logoutEndpoint: "https://sso.adalliance.io/api/users/globalsession/logout"
      });
      // eslint-disable-next-line no-undef
      sso.logout();
      this.showDialog = true;
    },
    titleClicked() {
      if (this.$route.path !== "/") {
        this.$router.push('/');
      }
    },
    alert(msg, type = 'info') {
      if (type === 'success') {
        this.$noty.success(msg);
      } else if (type === 'warning') {
        this.$noty.warning(msg);
      } else if (type === 'error') {
        this.$noty.error(msg);
      } else {
        this.$noty.info(msg);
      }
    },
    goToIndex() {
      this.$router.push('/surveys');
    }
  },
  computed: {}
}
</script>

<style lang="scss" scoped>
@use "@/assets/styles/variables.scss" as *;

#logo {
  width: $logoWidth;
  object-fit: contain;
  cursor: pointer;
  height: 100%;
  padding-left: 10px;
}

.header-container {
  width: $contentWidth;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  border-bottom: 1px solid #eeeeee;
  font-size: 17px;
  background-color: $headerBackground;
}

h1 {
  cursor: pointer;
}

a {
  color: #777777;
  cursor: pointer;
  font-size: 15px;
}

ul {
  list-style-type: none;
}

#logout {
  padding-top: 7px;
  display: flex;
  flex-flow: column;
  position: relative;
  cursor: pointer;
}

#logout span:last-child {
  top: -6px;
  position: relative;
}

#logout .icon {
  font-size: 2rem;
}

.nav-li-item > span {
  margin: auto;
  padding-top: 1em;
  padding-bottom: 1em;
}

.nav-li-item > a {
  margin: auto;
}

ul > a {
  display: flex;
  align-items: center;
}

#rootElement {
  background-color: $headerBackground;
}

.navbar {
  font-size: 17px;
  background-color: $headerBackground;
  padding-bottom: 10px;
}

.main-nav {
  list-style-type: none;
  display: none;
  height: 100%;
  padding-left: 0px;
}

.nav-links,
.logo, .toolName {
  text-decoration: none;
  color: inherit;
  height: 100%;
}

.toolName {
  font-size: 1.5em;
  font-weight: bold;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -o-user-select: none;
}

.toolNameWrapper {
  width: 6em;
  display: inline-block;
  padding-left: 2em;
}

.main-nav li {
  text-align: center;
}

.logo {
  display: inline-block;
  font-size: 22px;
  margin-top: 10px;
  margin-left: 20px;
}

.navbar-toggle {
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.8);
  font-size: 24px;
}

.active {
  display: block;
}

.logo > img {
  height: 30px;
}

@media screen and (min-width: 1025px) {

  .nav-content {
    width: 80%;
    margin: auto;
  }
  .navbar {
    justify-content: space-between;
    padding-bottom: 0;
    height: 70px;
    width: 90%;
    margin: auto;
    display: flex;
    align-items: center;
  }

  .logo > img {
    height: 45px;
  }

  .main-nav {
    display: flex;
    margin-right: 30px;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }

  .logo {
    margin-top: 0;
  }

  .navbar-toggle {
    display: none;
  }
  .nav-links {
    margin: 0;
    padding-left: 20px;
    padding-right: 20px;
    color: #000;
  }

  .nav-links.tab.active, .nav-links.tab:hover {
    border-top: 3px solid $pink;
    color: $pink;
  }
}

@media only screen and (max-width: 1650px) {
  .header-container {
    border-bottom: none;
  }
}
</style>